module.exports = __webpack_public_path__ + "img/category-sport.3e96a1fd.png";